import React, { useState } from 'react'
import { Minus, Plus } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import { normalizeQuantityInput } from '../../../utils/quantity'

const QuantityHandler = ({ value, onValueChange, inputDisabled }) => {
  // Se è settato onValueChange, il value è gestito esternamente
  // altrimenti si usa lo state (es. storybook)
  const t = useTrans()
  const [stateVal, setStateVal] = useState(value)
  const getVal = () => {
    const current = onValueChange ? value : stateVal
    return Number.isFinite(current) && current >= 0 ? current : 0
  }
  const changeVal = (newVal, action) => {
    onValueChange ? onValueChange(newVal, action) : setStateVal(newVal)
  }

  const displayedValue = getVal()

  return (
    <div className="quantity-handler">
      <button
        className="quantity-handler__button quantity-handler__button--minus"
        onClick={() => changeVal(Math.max(0, getVal() - 1), 'remove')}
        aria-label={t("Diminuisci di 1")}
      >
        <Minus />
      </button>
      <input
        className="quantity-handler__input"
        type="number"
        min="0"
        inputMode="numeric"
        value={displayedValue === 0 ? '' : displayedValue}
        onChange={(e) => changeVal(normalizeQuantityInput(e.target.value), 'set')}
        disabled={inputDisabled}
        placeholder="0"
        aria-label={t("Quantità")}
      ></input>
      <button
        className="quantity-handler__button quantity-handler__button--plus"
        onClick={() => changeVal(getVal() + 1, 'add')}
        aria-label={t("Aumenta di 1")}
      >
        <Plus />
      </button>
    </div>
  )
}

export default React.memo(QuantityHandler)
